import { render } from "./RunningOrderNote.vue?vue&type=template&id=003dc15d"
import script from "./RunningOrderNote.vue?vue&type=script&lang=js"
export * from "./RunningOrderNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__